import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";
import { Navbar } from "@/components/Navbar";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) {
      toast.success("Session initialized");
      navigate("/dashboard");
    } else {
      setErr(r.error);
      toast.error(r.error);
    }
  };

  return (
    <div className="min-h-screen bg-background bg-grid scanlines">
      <Navbar />
      <main className="mx-auto max-w-md px-6 py-16">
        <div className="border border-border bg-card">
          <div className="border-b border-border px-6 py-4 flex items-center justify-between">
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">// auth · login</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-emerald-400">secure</div>
          </div>
          <form onSubmit={submit} className="p-6 space-y-5" data-testid="login-form">
            <div>
              <h1 className="font-display font-bold text-3xl">Welcome back.</h1>
              <p className="mt-2 text-sm text-muted-foreground font-mono">{">"} access your timers and team sessions</p>
            </div>

            <div className="space-y-2">
              <Label className="font-mono text-[11px] uppercase tracking-widest" htmlFor="email">email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="rounded-none font-mono"
                placeholder="you@team.com"
                data-testid="login-email-input"
              />
            </div>

            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <Label className="font-mono text-[11px] uppercase tracking-widest" htmlFor="password">password</Label>
                <Link
                  to="/forgot-password"
                  className="font-mono text-[11px] uppercase tracking-widest text-primary hover:underline underline-offset-4"
                  data-testid="login-forgot-password-link"
                >
                  forgot?
                </Link>
              </div>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="rounded-none font-mono"
                placeholder="••••••••"
                data-testid="login-password-input"
              />
            </div>

            {err && (
              <div className="border border-destructive/40 bg-destructive/10 text-destructive font-mono text-xs px-3 py-2" data-testid="login-error">
                ! {err}
              </div>
            )}

            <Button
              type="submit"
              disabled={busy}
              className="w-full rounded-none font-mono uppercase tracking-widest h-11"
              data-testid="login-submit-button"
            >
              {busy ? "Authenticating…" : "Enter"}
            </Button>

            <div className="font-mono text-xs text-muted-foreground text-center">
              {">"} need an account?{" "}
              <Link to="/register" className="text-primary underline-offset-4 hover:underline" data-testid="login-to-register-link">
                initialize one
              </Link>
            </div>

<div className="font-mono text-xs text-muted-foreground text-center">
                {">"} link expired?{" "}
                <Link to="/forgot-password" className="text-primary underline-offset-4 hover:underline" data-testid="reset-password-request-new-link">
                  request a new one
                </Link>
              </div>
            
          </form>
        </div>
      </main>
    </div>
  );
}
